export function initializeNewsletterForm() {
  const $form = $("#newsletter-form");

  $form.validate({
    onfocusout: false,
    onkeyup: false,
    onclick: false,
    errorElement: "div",
    errorClass: "invalid-feedback mt-2",
    errorPlacement: function (error, element) {
      error.appendTo(element.closest(".block-newsletter-headband__form"));
    },
    highlight: function () {
      $form.addClass("invalid");
    },
    unhighlight: function () {
      $form.removeClass("invalid");
    },
    submitHandler: function () {
      $.ajax({
        type: "POST",
        url: $form.attr("action"),
        data: $form.serialize(),
        beforeSend: function () {
          $form.addClass("loading");
          $form.find(".feedback").remove();
          $form
            .find(".block-newsletter-headband__submit")
            .prop("disabled", true);
        },
        complete: function (data) {
          let alertClass =
            data.responseJSON.error || data.status !== 200
              ? "invalid-feedback"
              : "valid-feedback";
          let message = data.responseJSON.message;
          let alert = $(
            '<div class="feedback ' +
              alertClass +
              ' mt-2">' +
              message +
              "</div>"
          );
          $form.removeClass("loading");
          $form
            .find(".block-newsletter-headband__submit")
            .prop("disabled", false);
          alert.addClass("d-block");
          $form.find(".block-newsletter-headband__form").append(alert);
          if (!data.responseJSON.error || data.status === 200) {
            _paq.push([
              "trackEvent",
              "Newsletter",
              "Inscription réussie à la newsletter",
            ]);
            $(".form-control-newsletter").val("");
            setTimeout(() => {
              $form.find(".feedback").remove();
            }, 5000);
          }
        },
        dataType: "json",
      });
    },
  });
}
